import React from 'react';
import { AlertBanner } from '@sde/widgets-core/src/common/AlertBanner';
import { useAlerts } from 'src/state/alerts';
import { PermissionsModal } from './PermissionsModal';
import { NewSearchFlyout } from './NewSearchFlyout';
import { RecentSearchFlyout } from './RecentSearchFlyout';
import { SpouseOnlyModal } from './SpouseOnlyModal';
import { TrackItFlyout } from './TrackItFlyout';
import { ReactivateConfirmationModal } from './ReactivateConfirmationModal';
import { ReactivateTrainingTipModal } from './ReactivateTrainingTipModal';
import { NavMenuExitLinkModal } from './NavMenuExitLinkModal';
import { ChatBlockedModal } from './ChatBlockedModal';

export const HeaderModals = () => {
  const { alerts } = useAlerts.state();
  const { removeAlert } = useAlerts.actions();

  const handleClose = (index) => {
    removeAlert(index);
  };

  return (
    <React.Fragment>
      <AlertBanner alerts={alerts} onClose={handleClose} />
      <PermissionsModal />
      <NewSearchFlyout />
      <TrackItFlyout />
      <RecentSearchFlyout />
      <SpouseOnlyModal />
      <ReactivateConfirmationModal />
      <ReactivateTrainingTipModal />
      <NavMenuExitLinkModal />
      <ChatBlockedModal />
    </React.Fragment>
  );
};
